import * as React from 'react';

import { cn } from 'utils/shadcn';

const pathClassName = 'fill-neutral-900';

export default function SONARLogo(
  props: React.SVGProps<SVGSVGElement>
): React.JSX.Element {
  const { className, height = 16, width = 90, ...rest } = props;
  return (
    <svg
      role='img'
      aria-label='SONAR'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 4465.5 788.8'
      height={height}
      width={width}
      preserveAspectRatio='xMidYMid meet'
      className={cn('inline-block shrink-0', className)}
      {...rest}
    >
      <path
        className={pathClassName}
        d='M652.4,377c-14.1-8.5-33-14.7-56.6-18.4-23.6-3.7-58.7-5.6-105.4-5.6h-214c-66.1,0-109.7-7.2-130.6-21.6-21-14.4-31.4-40.8-31.4-79.2s10.7-63.9,32.2-78c21.5-14.1,63.1-21.2,125-21.2h203.2c60.8,0,100.6,6.9,119.4,20.6,18.8,13.7,28.2,40.2,28.2,79.4v9.2h71.2v-17.2c0-28.8-3.3-52.7-9.8-71.8-6.5-19.1-16.6-34.5-30.2-46.2-16.8-13.9-40-23.6-69.6-29.2-29.6-5.6-81.3-8.4-155.2-8.4h-135.2c-97.6,0-164.7,12.3-201.4,37-36.7,24.7-55,67.7-55,129s16.1,102.3,48.2,127c32.1,24.7,87.9,37,167.4,37h251.6c53.1,0,88.1,7,105.2,21,17.1,14,25.6,39.8,25.6,77.4s-12.3,75.6-36.8,91.6c-24.5,16-77.2,24-158,24h-155.6c-67.2,0-113.1-7.3-137.6-22-24.5-14.7-36.8-40.7-36.8-78s.3-12.1.8-23.6c.3-4.8.5-8.7.8-11.6H40.8c-.3,1.6-.4,3.9-.4,6.8-.8,17.9-1.2,30.5-1.2,38,0,56,17,96.1,51,120.2,34,24.1,91,36.2,171,36.2h202c92.8,0,157-13.1,192.6-39.2,35.6-26.1,53.4-72.3,53.4-138.4s-4.3-72.8-13-94.4c-8.7-21.6-23.3-38.4-43.8-50.4Z'
      />
      <path
        className={pathClassName}
        d='M1593.5,131c-18.9-14.9-44-25.6-75-32-31.1-6.4-78-9.6-140.7-9.6h-198.9c-62.7,0-109.6,3.2-140.7,9.6-31.1,6.4-56.1,17.1-75,32-21.1,16.8-36.3,39.9-45.6,69.2-9.3,29.3-14,68.8-14,118.4v162.4c0,45.3,4.7,81.9,14.2,109.6,9.5,27.7,24.9,50.1,46.2,67.2,19.2,15.2,44,25.9,74.4,32.2,30.4,6.3,77.5,9.4,141.3,9.4h198.1c64.3,0,111.6-3.1,141.9-9.4,30.3-6.3,54.9-17,73.8-32.2,20.5-16.3,35.6-38.8,45.2-67.6,9.6-28.8,14.4-66.4,14.4-112.8v-166c0-46.1-4.8-83.7-14.4-112.6-9.6-28.9-24.7-51.5-45.2-67.8ZM1573.1,460.2v20c0,31.2-1.7,54.2-5.2,69-3.5,14.8-9.2,27.5-17.2,38.2-11.8,15.5-28,26.5-48.8,33.2-20.8,6.7-50.4,10-88.9,10h-269.4c-38.4,0-68-3.3-88.9-10-20.8-6.7-37.1-17.7-48.8-33.2-8.5-11.2-14.5-24.5-18-39.8-3.5-15.3-5.2-40.9-5.2-76.6v-156.4c0-35.7,1.7-61.3,5.2-76.6,3.5-15.3,9.5-28.6,18-39.8,11.7-15.5,28-26.5,48.8-33.2,20.8-6.7,50.4-10,88.9-10h269.4c38.4,0,68,3.3,88.9,10,20.8,6.7,37.1,17.7,48.8,33.2,8,10.7,13.7,23.3,17.2,38,3.5,14.7,5.2,37.7,5.2,69.2v154.8Z'
      />
      <polygon
        className={pathClassName}
        points='2522.3 624.2 1983.9 96.6 1867.5 96.6 1867.5 692.2 1941.5 692.2 1941.5 156.6 2487.9 692.2 2595.9 692.2 2595.9 96.6 2522.3 96.6 2522.3 624.2'
      />
      <path
        className={pathClassName}
        d='M4428.3,309.8v-71.6c0-54.1-15.4-91.3-46.2-111.4-30.8-20.1-93.5-30.2-188.2-30.2h-425.2v64.8h449.2c53.3,0,88.7,6.7,106.2,20,17.5,13.3,26.2,40,26.2,80v28.4c0,40.3-8.7,67-26.2,80.2-17.5,13.2-52.9,19.8-106.2,19.8h-449.2v302.4h74v-233.6h361.2c62.1,0,101.7,7.1,118.6,21.2,16.9,14.1,25.4,40.7,25.4,79.6v132.8h74v-147.6c0-34.7-8.3-61.8-24.8-81.4-16.5-19.6-41.1-31.1-73.6-34.6,39.2-8.3,66.5-20.9,81.8-38,15.3-17.1,23-44,23-80.8Z'
      />
      <polygon
        className={pathClassName}
        points='3231.1 96.6 3132.7 96.6 2787.1 692.2 2871.5 692.2 2983.6 498.2 2983.5 498.2 3182.7 155.8 3385.1 498.2 3384.9 498.2 3499.1 692.2 3577.5 692.2 3231.1 96.6'
      />
    </svg>
  );
}
